import styled, { css } from "styled-components";

export const ToogleContainer = styled.div`
  display: flex;
  flex-direction: column;

  label {
    margin-bottom: 12px;
  }
`

const buttonVariants = {
  leftButton: css`
    border-radius: 4px 0px 0px 4px;
    margin-left: auto;
    height: 3rem;
    width: 100%;
    color: var(--white);
    background-color: var(--black-100);
    border: 1px solid var(--grey-200);
    font-family: Inter;
    font-size: 0.9rem;
  `,
  rightButton: css`
    border-radius: 0px 4px 4px 0px;
    margin-right: auto;
    height: 3rem;
    width: 100%;
    color: var(--white);
    background-color: var(--black-100);
    border: 1px solid var(--grey-200);
    font-family: Inter;
    font-size: 0.9rem;
  `,
  leftActive: css`
    border-radius: 4px 0px 0px 4px;
    margin-left: auto;
    height: 3rem;
    width: 100%;
    color: var(--white);
    background-color: var(--black-100);
    border: 1px solid var(--primary);
    font-family: Inter;
    font-size: 0.9rem;
  `,
  rightActive: css`
    border-radius: 0px 4px 4px 0px;
    margin-right: auto;
    height: 3rem;
    width: 100%;
    color: var(--white);
    background-color: var(--black-100);
    border: 1px solid var(--primary);
    font-family: Inter;
    font-size: 0.9rem;
  `
}

export const ToggleButton = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
`

type Props = {
  variant: 'rightActive' | 'leftActive' | 'rightButton' | 'leftButton'
}

export const Button = styled.button<Props>`
  ${({ variant }) => buttonVariants[variant]};
`